import { UsPortfolioClient } from './portfolioClient';
import { sendUsBrowserRequest, usBrowserSession } from './browserTradingClient';

/** Uses the app session and saved-evidence routes. Construction starts no
 * polling or venue traffic; mounting remains the US screen's responsibility. */
export function createUsBrowserPortfolioClient(): UsPortfolioClient {
  return new UsPortfolioClient({ session: usBrowserSession, send: sendUsBrowserRequest,
    uuid: () => crypto.randomUUID(), clock: Date.now });
}
